// extracted by mini-css-extract-plugin
module.exports = {"Component":"Section_Component__2_BCz","Content":"Section_Content__1Pg-6","Title":"Section_Title__2fEgo"};